// extracted by mini-css-extract-plugin
var _1 = "mECH42udruykbd0LLSgr";
export { _1 as "footerLeft" }
